import type { Venue } from '../../types/venue';

export const fyriResort: Venue = {
  id: 'fyri-resort',
  name: 'Fýri Resort',
  description: {
    en: `<p>Located in the high mountains of Norway lies Fýri, an all-year-round destination where you can meet by the pool, go for a walk-and-talk in the mountains or have a get together in one of our stunning meeting rooms. Our modern meeting spaces and the wide range of activities makes Fýri an ideal resort to load up with energy, breathe fresh air and have a really good time.</p>
    
    <p>What about just taking over the whole hotel? Imagine a Fýri filled with only your colleagues! With Fýri Resort all to yourself, you have 144 hotel rooms, Roa bar with shuffleboards and billiards, fantastic LIV Restaurant, a very own Pool Club and 8 different meeting rooms and endless possibilities to maximize the experience with activities, both indoor and outdoor.</p>`,
    
    sv: `<p>I de höga bergen i Norge ligger Fýri, en året-runt-destination där du kan träffas vid poolen, ta en promenad och prata i bergen eller ha en sammankomst i något av våra fantastiska mötesrum. Våra moderna möteslokaler och det breda utbudet av aktiviteter gör Fýri till en idealisk resort för att ladda upp med energi, andas frisk luft och ha en riktigt bra tid.</p>
    
    <p>Varför inte ta över hela hotellet? Föreställ dig ett Fýri fyllt med endast dina kollegor! Med Fýri Resort helt för er själva har ni 144 hotellrum, Roa bar med shuffleboards och biljard, fantastiska LIV Restaurant, en egen Pool Club och 8 olika mötesrum och oändliga möjligheter att maximera upplevelsen med aktiviteter, både inomhus och utomhus.</p>`,
    
    no: `<p>I de høye fjellene i Norge ligger Fýri, en helårsdestinasjon hvor du kan møtes ved bassenget, gå en walk-and-talk i fjellet eller ha en sammenkomst i et av våre fantastiske møterom. Våre moderne møtelokaler og det brede spekteret av aktiviteter gjør Fýri til et ideelt resort for å lade opp med energi, puste frisk luft og ha det skikkelig bra.</p>
    
    <p>Hva med å bare ta over hele hotellet? Tenk deg et Fýri fylt med bare dine kolleger! Med Fýri Resort helt for dere selv, har dere 144 hotellrom, Roa bar med shuffleboards og biljard, fantastiske LIV Restaurant, en egen Pool Club og 8 forskjellige møterom og uendelige muligheter for å maksimere opplevelsen med aktiviteter, både innendørs og utendørs.</p>`,
    
    da: `<p>I de høje bjerge i Norge ligger Fýri, en helårsdestination, hvor du kan mødes ved poolen, tage en walk-and-talk i bjergene eller have et møde i et af vores fantastiske mødelokaler. Vores moderne mødefaciliteter og det brede udvalg af aktiviteter gør Fýri til et ideelt resort til at lade op med energi, indånde frisk luft og have en virkelig god tid.</p>
    
    <p>Hvad med bare at overtage hele hotellet? Forestil dig et Fýri fyldt kun med dine kolleger! Med Fýri Resort helt for jer selv, har I 144 hotelværelser, Roa bar med shuffleboards og billard, fantastiske LIV Restaurant, en helt egen Pool Club og 8 forskellige møderum og uendelige muligheder for at maksimere oplevelsen med aktiviteter, både indendørs og udendørs.</p>`
  },
  image: '/assets/images/fyri.jpg',
  country: 'no',
  region: 'oslo',
  city: 'Hemsedal',
  address: 'Trondheimsvegen 150, 3560 Hemsedal, Norway',
  coordinates: {
    lat: 60.86120005627456,
    lng: 8.534641863686504
  },
  capacity: {
    min: 10,
    max: 460
  },
  rating: 4.8,
  reviews: Array.from({ length: 240 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.8,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa', 'gym'],
  images: [
    '/assets/images/fyri.jpg',
    'https://images.unsplash.com/photo-1610641818989-c2051b5e2cfd?auto=format&fit=crop&q=80&w=2000'
  ],
  priceRange: {
    min: 3000,
    max: 40000
  },
  recommended: false,
  factbox: {
    rooms: 144,
    conferenceRooms: 7,
    meetingCapacity: 460,
    features: [
      '144 hotel rooms',
      '7 meeting rooms',
      'Conference hall seats up to 252',
      'Conference rooms seat up to 460',
      '1000 sqm Pool Club',
      '3 restaurants',
      '2 swimming pools',
      'Located 3 hours from Oslo',
      'Mountain location with outdoor activities',
      'Roa bar with shuffleboards and billiards',
      'LIV Restaurant',
      'Option to book the entire resort'
    ]
  }
}; 